export const LANGUAGE_STATUS = {
  COMPLETE: 'complete',
  PARTIAL: 'partial',
  EMPTY: 'empty'
};

export const DEFAULT_LANGUAGE = {
  label: 'English',
  value: 'en'
};